import { render, staticRenderFns } from "./DayMeal.vue?vue&type=template&id=1f42e9f6&scoped=true&"
import script from "./DayMeal.vue?vue&type=script&lang=js&"
export * from "./DayMeal.vue?vue&type=script&lang=js&"
import style0 from "./DayMeal.scss?vue&type=style&index=0&id=1f42e9f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f42e9f6",
  null
  
)

export default component.exports